import { config } from '../config';
import { useQuery } from '@tanstack/react-query';
import { SchoolCustomizationHttpResponseBody } from '@ab/ams-school-api/types/private/v1';
import { useRequest } from '../lib/useRequest';

export type SchoolCustomizations = {
  schoolCustomization: {
    enablePreOfferLetterFeeFields: boolean;
    enablePreOfferLetterConditionDeadlineField: boolean;
    enableFinalOfferLetterFeeFields: boolean;
    enableFinalOfferLetterConditionDeadlineField: boolean;
    enableGpaCalculation: boolean;
  };
  featureFlags?: {
    [key: string]: boolean;
  };
};

export function useSchoolCustomizations() {
  const request = useRequest();

  const { data, isLoading, isError, isFetching, error } = useQuery({
    queryKey: ['v1_school_customizations'],
    queryFn: async (): Promise<SchoolCustomizations> => {
      const response = await request<SchoolCustomizationHttpResponseBody>(
        `${config.apiHost}/private/v1/school_customizations`,
        {
          method: 'GET',
          isExpectedResponse,
        }
      );

      return response;
    },
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    refetchIntervalInBackground: false,
  });

  return {
    schoolCustomizations: data,
    isSchoolCustomizationsError: isError,
    isLoadingSchoolCustomizations: isLoading,
    isFetchingSchoolCustomizations: isFetching,
    schoolCustomizationsError: error,
  };
}
function isExpectedResponse(res: unknown): res is SchoolCustomizationHttpResponseBody {
  return Boolean(res && typeof res === 'object');
}
